import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import Responsive from '../../assets/config/Responsive'
import Colors from '../../assets/styles/Colors'
//
//
const BirthDayInput: React.FC<{
  id: string
  label: string
  name?: string
  placeholder?: string
  value: string
  required?: boolean
  error?: boolean
  errorText?: string
  className?: string
  children?: React.ReactNode
  onChange: (value: any) => void
  onBlur?: (value: any) => void
  disabled?: boolean
  style?: React.CSSProperties
  width?: 'fullWidth' | 'default'
}> = ({
  id,
  label = '',
  name,
  placeholder,
  value,
  required,
  error = false,
  errorText,
  className,
  children,
  onChange,
  onBlur,
  disabled = false,
  style,
  width = 'default',
}) => {
  //
  //
  const currentYear = new Date().getFullYear()
  const inputRef = useRef<HTMLInputElement>(null)

  const checkBirthdayValue = (str: string, max: number) => {
    if (str.charAt(0) !== '0' || str === '00') {
      let num = parseInt(str)
      if (isNaN(num) || num <= 0 || num > max) num = 1
      if (num > parseInt(max.toString().charAt(0)) && num.toString().length === 1) {
        str = '0' + num
      } else {
        str = num.toString()
      }
    }
    return str
  }
  //
  //
  const day = value?.split('/')[0]
  const month = value?.split('/')[1]
  const year = value?.split('/')[2]
  //
  const getMaxDaysInMonth = (month: any, year: any) => {
    return new Date(year, month, 0).getDate()
  }
  //
  //
  const maxMonthDay = getMaxDaysInMonth(month, year)
  //
  //
  useEffect(() => {
    const inputElement = inputRef.current

    if (inputElement) {
      const handleInput = (e: Event) => {
        const target = e.target as HTMLInputElement
        target.type = 'text'
        let input = target.value
        if (/\D\/$/.test(input)) input = input.substr(0, input.length - 3)
        let values = input.split('/').map((v) => v.replace(/\D/g, ''))
        if (values[0]) values[0] = checkBirthdayValue(values[0], 31) // day check
        if (values[1]) values[1] = checkBirthdayValue(values[1], 12) // month check
        if (values[1]) values[1] = checkBirthdayValue(values[1], currentYear) // year check
        let output = values.map((v, i) => {
          return v.length === 2 && i < 2 ? v + ' / ' : v
        })
        target.value = output.join('').substr(0, 14)

        // Call the onChange callback with the updated value
        if (onChange) {
          onChange(target.value)
        }
      }

      inputElement.addEventListener('input', handleInput)

      return () => {
        inputElement.removeEventListener('input', handleInput)
      }
    }
  }, [currentYear, onChange])
  //
  //
  const daysIsNotValid = day && maxMonthDay && value && value.length === 14 && Number(day) > maxMonthDay
  //
  //
  return (
    <Wrapper style={style} className={className} $width={width}>
      {label ? (
        <LabelStyle $error={error || !!daysIsNotValid} htmlFor={`field-${id}`} className="birtyday-input">
          {label}
        </LabelStyle>
      ) : null}

      <InputStyle
        $error={error || !!daysIsNotValid}
        required={required}
        id={`field-${id}`}
        type="text"
        pattern="[0-9]*"
        name={name}
        placeholder={placeholder}
        disabled={disabled}
        ref={inputRef}
        value={value}
        onChange={(e) => {
          // Update the value through the onChange callback
          if (onChange) {
            onChange(e.target.value)
          }
        }}
        onBlur={onBlur}
      />

      {children}
      {error || !!daysIsNotValid ? (
        <ErrorMessage $error={error || !!daysIsNotValid} className={`field-${id}`}>
          {errorText}
        </ErrorMessage>
      ) : null}
    </Wrapper>
  )
}
//
const ErrorMessage = styled.div<{ $error: boolean }>`
  width: inherit;
  font-size: 14px;
  line-height: 16px;
  text-align: left;
  color: ${({ $error }) => ($error === true ? `${Colors.primaryRed}` : `${Colors.primaryGrey}`)};
  margin-top: 5px;
  /* position: absolute;
  bottom: -25px;
  left: 0; */
  /* z-index: 1; */
`
const LabelStyle = styled.label<{ $error: boolean }>`
  width: inherit;
  font-size: 14px;
  font-weight: normal;
  line-height: 16px;
  margin-bottom: 5px;
  text-align: left;
  padding-right: 25px;
  color: ${({ $error }) => ($error === true ? `${Colors.primaryRed}` : `${Colors.primaryGrey}`)};
`
const InputStyle = styled.input<{ $error: boolean }>`
  width: inherit;
  outline: none;
  padding: 15px 22px;
  font-size: 14px;
  line-height: 16px;
  border: 1px solid ${Colors.secondaryGrey};
  border-color: ${({ $error }) => ($error === true ? `${Colors.primaryRed}` : `${Colors.secondaryGrey}`)};
  border-radius: 4px;
  background-color: ${Colors.white};
  color: ${Colors.primaryBlack};

  :disabled {
    opacity: 0.7;
    background-color: ${Colors.secondaryGrey};
  }

  ::placeholder {
    color: ${Colors.nevadaGrey};
  }

  /* focus stlyes */
  &:focus {
    border-color: ${({ $error }) => ($error === true ? `${Colors.primaryRed}` : `${Colors.rollingStone}`)};
  }

  /* responsive */
  ${Responsive.tablet} {
    padding: 15px 18px;
  }
  ${Responsive.mobile} {
    padding: 15px 18px;
  }
`
const Wrapper = styled.div<{ $width: string }>`
  /* styles from props */
  width: ${({ $width }) => ($width === 'fullWidth' ? '100%' : '400px')};
  user-select: none;
  position: relative;
`
//
export default BirthDayInput
